<app-navbar-control></app-navbar-control>

<div class="pb-5" style="height: 100%; overflow-y: auto;">

    <div [innerHTML]="privacy"></div>
    <div class="mt-5"></div>
</div>